
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/water-cleanup",
      function () {
        return require("private-next-pages/services/water-cleanup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/water-cleanup"])
      });
    }
  